import React from 'react';
import { Helmet } from 'react-helmet';

import { APPLICATION_CONSTANTS } from 'AppConstants';

const MetaTags = (props) => {
	const { pageTitle, pageDesc } = APPLICATION_CONSTANTS;
	const { titleTxt = pageTitle, description = pageDesc, keywords } = props;
	return (
		<Helmet>
			<title>{titleTxt}</title>
			<meta name='description' content={description} />
			{keywords && <meta name='keywords' content={keywords} />}
		</Helmet>
	);
};

export default MetaTags;
